/*
 * block-manual-add.js
 *
 * Cancels add-to-cart requests for products in the Club Gifts collection and
 * (later) strips those items from non-member carts. Reads the blocked id sets
 * from window globals emitted by layout/theme.liquid. Loads deferred as the
 * first theme script so its fetch/XHR wrappers are installed before any
 * cart code registers a handler.
 */
(function () {
  'use strict';

  var PRODUCT_IDS = window.__blockedManualAddProductIds || new Set();
  var VARIANT_IDS = window.__blockedManualAddVariantIds || new Set();

  if (PRODUCT_IDS.size === 0 && VARIANT_IDS.size === 0) return;

  function isCartAddUrl(url) {
    if (!url) return false;
    return /(^|\/)cart\/add(\.js)?(\?|$)/.test(String(url));
  }

  function isBlockedVariantId(id) {
    if (id == null) return false;
    return VARIANT_IDS.has(Number(id)) || VARIANT_IDS.has(String(id));
  }

  function collectIdsFromObject(obj) {
    if (!obj) return [];
    if (obj.id != null) return [obj.id];
    if (Array.isArray(obj.items)) {
      return obj.items.map(function (i) { return i && i.id; }).filter(Boolean);
    }
    return [];
  }

  function extractIdsFromPayload(body) {
    if (!body) return [];
    try {
      if (body instanceof FormData) {
        var out = [];
        body.forEach(function (v, k) {
          if (k === 'id' || /items\[\d+\]\[id\]/.test(k)) out.push(v);
        });
        return out;
      }
      if (body instanceof URLSearchParams) {
        var out = [];
        body.forEach(function (v, k) {
          if (k === 'id' || /items\[\d+\]\[id\]/.test(k)) out.push(v);
        });
        return out;
      }
      if (typeof body === 'string') {
        var trimmed = body.trim();
        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          return collectIdsFromObject(JSON.parse(trimmed));
        }
        var params = new URLSearchParams(body);
        var arr = [];
        params.forEach(function (v, k) {
          if (k === 'id' || /items\[\d+\]\[id\]/.test(k)) arr.push(v);
        });
        return arr;
      }
      if (typeof body === 'object') {
        return collectIdsFromObject(body);
      }
    } catch (e) { /* malformed payload — let it through */ }
    return [];
  }

  function blockedResponse() {
    return new Response(
      JSON.stringify({ status: 422, description: 'blocked-manual-add' }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    );
  }

  var origFetch = window.fetch && window.fetch.bind(window);

  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var method = ((init && init.method) || (typeof input === 'object' && input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && isCartAddUrl(url)) {
        var body = init && init.body;
        var ids = extractIdsFromPayload(body);
        if (ids.some(isBlockedVariantId)) {
          try {
            document.dispatchEvent(new CustomEvent('cart:add-blocked', {
              detail: { source: 'fetch', ids: ids }
            }));
          } catch (e) {}
          return Promise.resolve(blockedResponse());
        }
      }
      return origFetch(input, init);
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bma_method = method;
    this.__bma_url = url;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    var method = String(this.__bma_method || '').toUpperCase();
    if (method === 'POST' && isCartAddUrl(this.__bma_url)) {
      var ids = extractIdsFromPayload(body);
      if (ids.some(isBlockedVariantId)) {
        try {
          document.dispatchEvent(new CustomEvent('cart:add-blocked', {
            detail: { source: 'xhr', ids: ids }
          }));
        } catch (e) {}
        var xhr = this;
        setTimeout(function () {
          var responseText = '{"status":422,"description":"blocked-manual-add"}';
          var responseType = xhr.responseType;
          var responseValue = (responseType === 'json')
            ? { status: 422, description: 'blocked-manual-add' }
            : responseText;
          Object.defineProperty(xhr, 'readyState', { configurable: true, get: function () { return 4; } });
          Object.defineProperty(xhr, 'status', { configurable: true, get: function () { return 422; } });
          Object.defineProperty(xhr, 'statusText', { configurable: true, get: function () { return 'Unprocessable Entity'; } });
          Object.defineProperty(xhr, 'responseText', { configurable: true, get: function () { return responseText; } });
          Object.defineProperty(xhr, 'response', { configurable: true, get: function () { return responseValue; } });
          if (typeof xhr.onreadystatechange === 'function') { try { xhr.onreadystatechange(); } catch (e) {} }
          try { xhr.dispatchEvent(new Event('readystatechange')); } catch (e) {}
          if (typeof xhr.onload === 'function') { try { xhr.onload(); } catch (e) {} }
          try { xhr.dispatchEvent(new Event('load')); } catch (e) {}
          if (typeof xhr.onloadend === 'function') { try { xhr.onloadend(); } catch (e) {} }
          try { xhr.dispatchEvent(new Event('loadend')); } catch (e) {}
        }, 0);
        return;
      }
    }
    return origSend.apply(this, arguments);
  };

  function isBlockedProductId(id) {
    if (id == null) return false;
    return PRODUCT_IDS.has(Number(id)) || PRODUCT_IDS.has(String(id));
  }

  function guardPdpButton() {
    var pid = null;
    try {
      pid = window.ShopifyAnalytics &&
            window.ShopifyAnalytics.meta &&
            window.ShopifyAnalytics.meta.product &&
            window.ShopifyAnalytics.meta.product.id;
    } catch (e) {}
    if (!pid) {
      var productInfo = document.querySelector('product-info[data-product-id]');
      if (productInfo) pid = productInfo.getAttribute('data-product-id');
    }
    if (!isBlockedProductId(pid)) return;
    document.body.classList.add('js-blocked-manual-add');
    var buttons = document.querySelectorAll('form[action*="/cart/add"] [name="add"]');
    buttons.forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardPdpButton);
  } else {
    guardPdpButton();
  }

  function isBlockedProductOrVariant(item) {
    if (!item) return false;
    if (PRODUCT_IDS.has(Number(item.product_id)) || PRODUCT_IDS.has(String(item.product_id))) return true;
    if (VARIANT_IDS.has(Number(item.id)) || VARIANT_IDS.has(String(item.id))) return true;
    return false;
  }

  var sweeping = false;

  function sweep() {
    if (sweeping) return;
    if (document.body.classList.contains('is-club-member--effective')) return;
    // Also read server-truth attrs so a real member's gift isn't stripped
    // during the brief window before club-effective-state.js sets the class.
    // NB: layout/theme.liquid renders data-isClubMember with a trailing space
    // in the true branch ("true "), so trim before comparing.
    var body = document.body;
    var memberAttr = (body.getAttribute('data-isClubMember') || '').trim();
    var validAttr = (body.getAttribute('data-club-valid-member') || '').trim();
    if (memberAttr === 'true' && validAttr === 'true') return;
    sweeping = true;
    origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return null;
        var updates = {};
        var hit = false;
        cart.items.forEach(function (i) {
          if (isBlockedProductOrVariant(i)) {
            updates[i.key] = 0;
            hit = true;
          }
        });
        if (!hit) return null;
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          try {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { source: 'block-manual-add-sweep' }
            }));
          } catch (e) {}
          // /cart renders cart-remove-button with a server-side data-index.
          // After we mutate Shopify's cart, those indexes go stale — the
          // theme's own remove handler at assets/cart.js:20 posts line=N to
          // /cart/change and Shopify returns 422 "line parameter not valid"
          // for any index past the new item_count. Reloading forces a fresh
          // server render so data-index values match Shopify's cart state.
          var path = window.location.pathname || '';
          if (path === '/cart' || path.indexOf('/cart/') === 0 || path.indexOf('/cart?') === 0) {
            window.location.reload();
          }
        });
      })
      .catch(function () { /* swallow — sweep is best-effort */ })
      .then(function () { sweeping = false; });
  }

  document.addEventListener('club:effective-state', sweep);
  if (document.readyState === 'complete') {
    setTimeout(sweep, 0);
  } else {
    // 500ms lets club-effective-state.js's own /cart.js fetch settle so its
    // is-club-member--effective class is applied before the fallback sweep
    // runs — see the server-truth guard above for the same protection.
    window.addEventListener('load', function () { setTimeout(sweep, 500); });
  }
})();
